import Advertising from "@/components/Advertising/Advertising.vue";
import ArticleAuthor from "@/components/ArticleAuthor/ArticleAuthor.vue";
import { getCurrentSubdomain, isSmallDevice } from "@/common/functions";

const adUnitIds = {
    examples: "Examples",
};

export default {
    name: "ArticleBody",
    components: {
        Advertising,
        ArticleAuthor
    },
    props: {
        title: {
            type: String,
            required: true,
            default: ""
        },
        articleBody: {
            type: String,
            default: ""
        },
        articleBodyTop: {
            type: String,
            default: ""
        },
        articleBodyMiddle: {
            type: String,
            default: ""
        },
        articleBodyBottom: {
            type: String,
            default: ""
        },
        author: {
            type: String,
            default: ""
        }
    },
    computed: {
        parentAdUnit() {
            return adUnitIds[getCurrentSubdomain()] || 'Reference';
        },
        isSmallDevice
    },
    methods: {
        virtualPVHit(title, location) {
            this.$ga.page({
                page: this.$route.path,
                title,
                location
            });
        }
    },
    /**
     * Here we need to get all these nodes after v-html has rerendered them,
     * so it's necessary to attach a listener in the updated hook
     * Doc: https://vuejs.org/v2/api/#updated
     */
    updated() {
        this.$nextTick(() => {
            const pdfImages = document.getElementsByClassName("pdf-image-btn");
            for (let i = 0; i < pdfImages.length; i++) {
                pdfImages[i].addEventListener("click", () => {
                    const img = pdfImages[i].querySelector("img");
                    const title = img.getAttribute("alt");
                    const link = img.getAttribute("link");
                    this.virtualPVHit(title, link);
                });
            }

            const pdfButton = document.getElementsByClassName("pdf-btn");
            for (let i = 0; i < pdfButton.length; i++) {
                pdfButton[i].addEventListener("click", () => {
                    const button = pdfButton[i];
                    const link = button.getAttribute("href");
                    const title = pdfImages[i].querySelector("img").getAttribute("alt");
                    this.virtualPVHit(title, link);
                });
            }
        });
    },
    beforeDestroy() {
        const pdfImages = document.getElementsByClassName("pdf-image-btn");
        for (let i = 0; i < pdfImages.length; i++) {
            pdfImages[i].removeEventListener("click", () => {
                this.virtualPVHit();
            });
        }

        const pdfButton = document.getElementsByClassName("pdf-btn");
        for (let i = 0; i < pdfButton.length; i++) {
            pdfButton[i].removeEventListener("click", () => {
                this.virtualPVHit();
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/ArticleBody/ArticleBody.js